import { MapID } from "config/enums/mapIDs";

export const isValidMapID = (id: number) => id in MapID;
